export enum FaillureType {
	ChannelNotFound,
	EmlReadingFail,
	FolderCreationFail,
	FinalizationFail,
	AttributeAssignmentFail,
	CustomerIdentificationFail,
	DocumentIdentificationFail,
	ChannelRetrivingFail,
	RoutingFail,
	AutoLinkFail,
	AddressInactive,
}
